import React from 'react'
// hooks
import { useCurrentUser, useShowModal } from 'hooks'
// components
import { IconButton } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// icons
import { VerginaSunIcon } from 'components/UI/Icons'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { AiChatContext } from 'components/Modals/AiChatModal/types'

const AiChatButton: React.FC = () => {
  const { risk } = React.useContext(RiskAPIContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const {
    permissionsFromSecurityGroups: { aiEnableUsage }
  } = useCurrentUser()

  const { showModal } = useShowModal({ modalType: Modals.AI_CHAT_MODAL })

  if (!aiEnableUsage || !riskTemplate?.aiEnabled || !risk?.id) {
    return null
  }

  const prefix = riskTemplate.customerUniqueIdPrefix
  const postfix = risk.customerUniqueIdPostfix
  const title = prefix && postfix ? `${prefix}${postfix} - ${riskTemplate.name}` : riskTemplate.name

  const context: AiChatContext = {
    title,
    type: 'risk',
    riskId: risk.id,
    riskTemplateId: riskTemplate.id
  }

  return (
    <IconButton description='AI Chat' onClick={() => showModal({ context })}>
      <VerginaSunIcon />
    </IconButton>
  )
}

export default AiChatButton
